import { BrowserRouter, useRoutes } from "react-router-dom";
import {
  Container,
  SnackbarProvider,
  useInitLang,
} from "@yuno/dashboard-container-mfe";
import MainLayout from "./layouts/main-layout";
import { NewCheckoutBuilder } from "./pages/checkout-builder/new-checkout-builder";
import { MainProvider } from "./context/main-context";
import { ThemeProvider } from "./context/theme-context";
import { I18nextProvider } from "react-i18next";
import i18n from "i18next";
import en from "./lang/en.json";
import es from "./lang/es.json";
import pt from "./lang/pt.json";

const mainRoutes = {
  path: "/checkout-builder",
  element: <MainLayout />,
  children: [{ path: "/checkout-builder", element: <NewCheckoutBuilder /> }],
};

const Routing = () => {
  const routing = useRoutes([mainRoutes]);
  return <>{routing}</>;
};

export default function Root() {
  const i18Instance = useInitLang({ i18n, en, es, pt });

  return (
    <Container content>
      <BrowserRouter>
        <SnackbarProvider>
          <ThemeProvider>
            <I18nextProvider i18n={i18Instance}>
              <MainProvider>
                <Routing />
              </MainProvider>
            </I18nextProvider>
          </ThemeProvider>
        </SnackbarProvider>
      </BrowserRouter>
    </Container>
  );
}
